import React, { useMemo } from "react";

import { compareKeys } from 'mythil/object';
import { useSelector } from 'react-redux'
import { getSubviewTree } from '~/stateGetter';

import ItemViewDialog from "~/ui/ItemViewDialog/ItemViewDialog";
import { presentActiveRelationshipFieldTree } from "~/statePresenter";

export default function ModelDialogTree() {
    const tree = useSelector((state) => getSubviewTree(state), compareKeys) as Record<string, { hasSubviews: boolean, gridName: string }>;
    const activeRelationshipFieldsTree = useSelector((state) => presentActiveRelationshipFieldTree(state), compareKeys);
    
    const dialogs = useMemo(() => Object.entries(tree)
        .map(([modelId, { hasSubviews: showFullscreen, gridName }]) => (
            <ItemViewDialog
                modelId={modelId}
                key={modelId}
                gridName={gridName}
                size={showFullscreen ? "large-auto" : undefined}
            />
        )),
        [tree]
    );
        
    const relationFieldDialog = useMemo(() => Object.entries(activeRelationshipFieldsTree)
        .sort()
        .map(([modelId, showFullscreen]) => (
            <ItemViewDialog
                modelId={modelId}
                key={"relationship-field--" + modelId}
                canClose={false}
                size={showFullscreen ? "large-auto" : undefined}
                enableSubviews={false}
            />
        )),
        [activeRelationshipFieldsTree]
    );

    return <>
    { dialogs }
    { relationFieldDialog }
    </>
}

